// extracted by css-extract-rspack-plugin
export default {"sectionRegionContainer":"sectionRegion-module__sectionRegionContainer","commonSection":"sectionRegion-module__commonSection"};